import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { TaskMetadata } from 'aos-services/src/services/tasks/types/TaskMetadata'
import { TaskType } from 'aos-services/src/services/tasks/types/TaskType'
import React, { FC } from 'react'
import { useWatch } from 'react-hook-form'

import { AnimalsTaskForm } from './AnimalsTaskForm'
import { DeIcingTaskForm } from './DeIcingTaskForm'
import { InspectionTaskForm } from './InspectionTaskForm'
import { MaintenanceTaskForm } from './MaintenanceTaskForm'
import { RefuellingTaskForm } from './RefuellingTaskForm'
import { RescueServiceTaskForm } from './RescueServiceTaskForm'
import { TerminalTaskForm } from './TerminalTaskForm'

interface DetailedTaskFormProps {
    metadata: TaskMetadata
    isTaskTemplate: boolean
}

export const DetailedTaskForm: FC<DetailedTaskFormProps> = ({ metadata, isTaskTemplate }) => {
    const payload = useWatch() as TaskFormPayload
    switch (payload?.type) {
        case TaskType.AnimalPrevention:
            return <AnimalsTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.DeIcing:
            return <DeIcingTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.Maintenance:
            return <MaintenanceTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.RescueService:
            return <RescueServiceTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.Terminal:
            return <TerminalTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.Inspection:
            return <InspectionTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        case TaskType.Refuelling:
            return <RefuellingTaskForm metadata={metadata} isTaskTemplate={isTaskTemplate} />

        default:
            return null
    }
}
